import { type ApiError } from 'src/lib/error';

import { ApiActions } from '../constants/ApiActions';
import { ERROR_KEY, errorTypes, UserProfileActions } from '../constants/UserProfile';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [ERROR_KEY]: '',
});
export type UserProfileState = typeof INITIAL_STATE;

// USERPROFILE REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.GET_PROFILE_FAIL]: getProfileFail,
  [ApiActions.GET_PROFILE_SUCCESS]: getProfileSuccess,
  [UserProfileActions.RESET_ERROR_KEY]: resetErrorKey,
});

// CASE FUNCTIONS

function getProfileFail(state: UserProfileState, action: $TSFixMe): UserProfileState {
  return state.set(ERROR_KEY, (action.error as ApiError).errorType);
}

function getProfileSuccess(state: UserProfileState, action: $TSFixMe): UserProfileState {
  const listenerData = action.response.entities.listeners[action.response.result];
  const isProfilePrivate = listenerData.private;
  // Only your own profile would satisfy both isProfilePrivate and have stationCount in data
  // stationCount only in data if own user, or other public user.
  if (isProfilePrivate && listenerData.stationCount === undefined) {
    return state.set(ERROR_KEY, errorTypes.privateProfile);
  }
  return state;
}

function resetErrorKey(state: UserProfileState): UserProfileState {
  return state.set(ERROR_KEY, '');
}
